import React from "react";
import CommonButton from "@/components/common/CommonButton";
import CommonVideoButton from "@/components/common/CommonVideoButton";
import { BookDemoHubspotButtonUrl } from "@/utils/hubspot-contants";
import { CiMobile4 } from "react-icons/ci";

const ButtonsSection: React.FC = () => (
  <div className="flex items-center justify-end gap-4 pt-3">
    <CommonButton
      text="Book a Demo"
      url={BookDemoHubspotButtonUrl}
      textWeightMedium
      version="white"
      textSizeBtnClass="!text-[#323339] !pt-[9px] !pb-[9px] !pl-3 !pr-3 text-[14px]"
    />
    <CommonVideoButton
      text="Watch Video"
      url="https://www.youtube.com/embed/yTM3v5m4upk?autoplay=1"
      textWeightMedium
      watchIcon
      customClass="!text-[#323339] !pt-[7px] !pb-[7px] !pl-3 !pr-3 text-[14px] !border-[#D0D5DD]"
    />
    <CommonButton
      text="Download App"
      url={"/download"}
      textWeightMedium
      version="white"
      target="none"
      textSizeBtnClass="!text-[#323339] !pt-[9px] !pb-[9px] !pl-3 !pr-3 text-[14px]"
      customIcon={<CiMobile4 color="#323339" size={20} />}
    />

  </div>
);

export default ButtonsSection;
